import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import CobeeTextField from "../../../../../app/components/CobeeTextField";
import { translate as t } from "../../../../translate/localization";
import useStyles from "../../styles";

export default function RowInitialPrice({ initialAmount, setInitialAmount }) {
  const { secondColumn, inputLabel } = useStyles();
  return (
    <>
      <Grid item xs={6}>
        <Typography variant="body2">
          {`${t("common-messages.initial-price")} ${t(
            "common-messages.optional"
          )}:`}
        </Typography>
        <Typography variant="body2">
          {t("request-section.initial-price-message")}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        alignItems="flex-start"
        className={secondColumn}
      >
        <Grid item xs={12} container alignItems="center">
          <Grid item xs={4}>
            <CobeeTextField
              type="number"
              minWidth="100%"
              min={0}
              value={initialAmount}
              onChange={(e) => setInitialAmount(e.target.value)}
            />
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body2" className={inputLabel}>
              EUR ({t("common-messages.tax-not-included")})
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

RowInitialPrice.propTypes = {
  initialAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setInitialAmount: PropTypes.func,
};

RowInitialPrice.defaultProps = {
  initialAmount: "0",
  setInitialAmount: () => {},
};
